import React, { useEffect, useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  EditButton,
  DeleteButton,
  Pagination,
  useGetIdentity,
  FilterList,
  Loading,
  FilterListItem,
  Filter,
  TopToolbar,
  CreateButton,
} from 'react-admin';
import { Button, Card, CardContent } from '@mui/material';
import CategoryIcon from '@mui/icons-material/LocalOffer';
import ToggleRowStyle from './Common';
import { supabaseClient } from './supabase';

const ListActions = () => {
  return (
    <TopToolbar>
      <CreateButton to={`/discipline/create`} />
    </TopToolbar>
  );
};

const DisciplineFilterSideBar = (props) => {
  const { studentData, identity } = props;

  const grades = [1,2,3,4,5,6,7].map((grade) => ({
    id: grade,
    name: `Grade ${grade}`,
  }));

  return (
    <Card sx={{ order: -1, mr: 2, mt: 8, width: 380 }}>
      <CardContent>
        <FilterList label="Grades" icon={<CategoryIcon />}>
          {grades.map((grade) => (
            <FilterListItem
              sx={{ 
                borderLeft: `10px solid #${Math.floor(Math.random()*16777215).toString(16).padStart(6, '0')}`, 
                margin: 1 
              }}
              label={grade.name}
              value={{ grade: grade.id }}
              key={grade.id}
            />
          ))}
        </FilterList>
      </CardContent>
    </Card>
  );
};

const DisciplineFilters = (props) => (
  <Filter {...props}>
    <SearchInput placeholder="Search title" source="title@ilike" alwaysOn />
  </Filter>
);

const DisciplineList = (props) => {
  const [studentData, setStudentData] = useState(false);
  const {
    data: identity,
    isLoading: isIdentityLoading,
    error: identityError,
  } = useGetIdentity();

  useEffect(() => {
    if (identity !== null) {
      getStudents(identity);
    }
  }, [identity]);

  const getStudents = async (identity) => {
    let options = {};
    if (identity) {
      switch (identity.role) {
        case 'parent':
          options = {
            household_hash: `${identity.household_hash}`,
          };
          break;
        case 'teacher':
          if (identity.class_id !== null) {
            options = {
              class_id: identity.class_id,
            };
          } else {
            options = {
              grade: identity.grade,
            };
          }
          break;
        default:
          break;
      }
      const { data, error } = await supabaseClient
        .from('students')
        .select(
          `
          id,
          first_name,
          last_name,
          class_id,
          household_hash,
          classes (
            id,
            class_code,
            grade
          )
        `
        )
        .match(options);
      if (error)
        throw new Error(`Error fetching the students: ${error.message}`);
      console.log(`studentData: ${JSON.stringify(data)}`);
      setStudentData(data);
    }
  };

  if (isIdentityLoading) return <>Loading....</>;
  if (identityError) return <>Error...</>;

  return (
    studentData && (
      <List
        {...props}
        actions={['admin', 'teacher'].includes(identity.role) ? <ListActions /> : null}
        aside={
          <DisciplineFilterSideBar
            studentData={studentData}
            identity={identity}
          />
        }
        filters={<DisciplineFilters />}
        filterDefaultValues={
          identity.role === 'parent'
            ? { grade: studentData[0]?.classes.grade }
            : {}
        }
        title="Discipline Records"
        sx={{
          '& .RaDatagrid-table tr td:last-child': {
            maxWidth: '40%',
            width: '20%',
          },
        }}
      >
        <Pagination />
        <Datagrid
          rowStyle={ToggleRowStyle}
          bulkActionButtons={false}
          key={(record) => `${record.id}`}
          rowClick={'show'}
        >
          <TextField source="title" />
          {['admin', 'teacher'].includes(identity.role) ? (
            <TextField source="grade" label="Grade" />
          ) : null}
          {['admin', 'teacher'].includes(identity.role) ? (
            <>
              <EditButton />
              <DeleteButton mutationMode="pessimistic" />
            </>
          ) : null}
        </Datagrid>
      </List>
    )
  );
};

export default DisciplineList;
